import React, { Component } from 'react'
import { OperationStart } from 'stylewhere/components'
import { TransferToZoneExtensions } from 'stylewhere/extensions'

export default class TransferToZoneStart extends Component {
  render() {
    return <OperationStart submitPath="/transfer-to-zone/:opCode/reading" extensions={TransferToZoneExtensions} />
  }
}
